import { useMemo, useState } from "react";

import { Zoom } from "../../Zoom";

import ZoomInIcon from "../../../images/zoom-in.png";

export function Option({
  isTF,
  optionId,
  value,
  image,
  isPraticeSession,
  isCorrectOption,
  isSelected,
  selectOption,
}) {
  const [zoom, setZoom] = useState(false);

  const showSelected = useMemo(() => {
    return isPraticeSession ? isSelected : isCorrectOption;
  }, [isPraticeSession, isCorrectOption, isSelected]);

  const checkStyle = useMemo(() => {
    if (!showSelected) return null;

    if (isPraticeSession) {
      return {
        backgroundColor: "#4bdf3f",
      };
    } else {
      return {
        backgroundColor: "#ff8cb0",
      };
    }
  }, [isPraticeSession, showSelected]);

  const imageURL = useMemo(() => {
    if (!image) return null;
    return image.trim().startsWith("https://drive.g") ? null : image;
  }, [image]);

  return (
    <div
      className={
        isPraticeSession ? "opt1-container ps-op1" : "opt1-container ot-op1"
      }
      style={{
        backgroundColor: isSelected ? "#CDFFE1" : "",
      }}
    >
      <div
        onClick={selectOption}
        style={{
          position: "relative",
          width: "100%",
        }}
      >
        <span
          style={{ fontSize: "1.2rem", textTransform:isTF?"capitalize":"" }}
          dangerouslySetInnerHTML={{
            __html:
              value ||
              "<span style='visibility:hidden !important'>Empty Option</span>",
          }}
        ></span>
        <input type="radio" name="radio" id={optionId} />
        <div
          className={
            isPraticeSession ? "checkmark ps_check" : "checkmark ot_check"
          }
        >
          <span
            style={{
              display: "block",
              width: "12px",
              height: "12px",
              margin: "auto",
              borderRadius: "100%",
              ...checkStyle,
            }}
          ></span>
        </div>
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            cursor: "pointer",
            zIndex: 10,
          }}
        ></div>
      </div>

      <div
        className="imgBlock"
        onClick={() => setZoom(true)}
        style={
          imageURL
            ? {
                position: "relative",
                display: "flex",
                width: "80%",
                maxWidth: "300px",
                height: "fit-content",
                margin: "10px",
                cursor: "zoom-in",
                borderRadius: "0px",
              }
            : { display: "none" }
        }
      >
        <img
          src={imageURL}
          style={{
            height: "100%",
            aspectRatio: "auto",
          }}
        />
        <img
          src={ZoomInIcon}
          alt="zoom"
          style={{
            width: "20px",
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 50,
          }}
        />
      </div>
      {imageURL && (
        <Zoom
          image={imageURL}
          zoom={zoom}
          close={() => setZoom(false)}
          hideIcon={true}
        />
      )}
    </div>
  );
}

export function QuestionImg(props) {
  const [zoom, setZoom] = useState(false);
  const isValidImage = useMemo(() => {
    const image = props.image;
    if (!image) return false;
    return image.startsWith("https://drive.g") ? false : true;
  }, [props.image]);
  return (
    isValidImage ? <div className="image-wrapper" style={{ position: "relative" }}>
      <img onClick={() => setZoom(true)} src={props.image} />
      <Zoom image={props.image} zoom={zoom} close={() => setZoom(false)} />
    </div>:<></>
  );
}

export function QuestionMedia({ url }) {
  const [zoom, setZoom] = useState(false);

  const mediaType = useMemo(() => {
    if (!url) return null;

    const cleanUrl = url.split("?")[0].toLowerCase();

    if (cleanUrl.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/)) return "image";
    if (cleanUrl.match(/\.(mp4|webm|ogg|mov)$/)) return "video";
    if (cleanUrl.match(/\.(mp3|wav|ogg|aac)$/)) return "audio";

    return null;
  }, [url]);

  if (!url || !mediaType) return null;

  console.log(url, mediaType);

  return (
    <div className="media-wrapper" style={{ position: "relative" }}>
      {mediaType === "image" && (
        <>
          <img
            src={url}
            onClick={() => setZoom(true)}
            style={{ cursor: "pointer", maxWidth: "100%" }}
          />
          <Zoom image={url} zoom={zoom} close={() => setZoom(false)} />
        </>
      )}

      {mediaType === "video" && (
        <video controls style={{ maxWidth: "100%" }}>
          <source src={url} />
          Your browser does not support video.
        </video>
      )}

      {mediaType === "audio" && (
        <audio controls style={{ width: "100%" }}>
          <source src={url} type="audio/mp3"/>
          Your browser does not support audio.
        </audio>
      )}
    </div>
  );
}
